




import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown-v2'

@Component({
    components: {
       VueMarkdown
    }
})
export default class RenderMarkdown extends Vue {
   @Prop({default: null}) source: string | null  

    mounted() {}
}
